import { KeyValue } from "@/main/models/common";
import { StatusRegisterTypes, StatusRegisterActionTypes } from "./statusRegisterTypes";

export function getStatusRegister(showPending: boolean = false): StatusRegisterActionTypes {
	return {
		type: StatusRegisterTypes.GET_STATUS_REGISTER,
		payload: { showPending },
	};
}

export function saveStatusRegister(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): StatusRegisterActionTypes {
	return {
		type: StatusRegisterTypes.SAVE_STATUS_REGISTER,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerStatusRegister(): StatusRegisterActionTypes {
	return {
		type: StatusRegisterTypes.RESET_REDUCER_STATUS_REGISTER,
	};
}
